import * as React from 'react'
import {type ResourceStatusT} from '@freckle/resource-status'
import type {LaunchControlReturn} from './components/use-launch-control-return'

export type ChromeContextValue = {
  launchControlReturn: ResourceStatusT<LaunchControlReturn | null>
  chromeParam: string | null
  enabled: boolean
}

export const ChromeContext = React.createContext<ChromeContextValue | null>(null)

export function useChromeContext(): ChromeContextValue | null {
  return React.useContext(ChromeContext)
}
